import { HelpNetworkOutlineIcon } from './HelpNetworkOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 918BA71B-ED4F-4259-9089-0CF2A1EDCFD1
 * name help-network-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/help-network-outline.svg
 * tags
 */
export const QuestionNetworkOutlineIcon = HelpNetworkOutlineIcon;
export default QuestionNetworkOutlineIcon